if($('#submit-application').length){
    var app = new Vue({
        el: '#submit-application',
        data: {
            showTerms:false
        }
    });
}